import React from 'react';
// import { GoogleMaps } from "../../Fonctions.js";
// import affiche from '../../Resources/affiche.png';

import Chiffres from "./Chiffres.js"

function Deontologie({className}) {
return (
    <section className={`bandeau ${className}`}>
        {/* <section className="bandeau bleu bandeau-top"> */}
        <div className='row'>
            <div className="col">
                <div className="entete">
                    <div className='entete-left'>
                        <div className='testgrid'>
                            <h1>Et de 5, l'édition 2026 est terminée.</h1>
                            <h1>Les photos sont en ligne. Rendez-vous dans la galerie !</h1>
                            <Chiffres></Chiffres>
                            <h1>A l'année prochaine.</h1>
                            <h1>On vous attend toujours plus nombreux pour aider la recherche contre les sarcomes.</h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

)}

export default Deontologie;